import type { LocationQuery, RouteRecordNormalized } from '#vue-router'
import { coreServerConfig, useRuntimeConfig } from '#imports'
import { landingPageTarget } from './landingPageTarget'

/** Server only: where the `landing-page` middleware sends `to`, if anywhere; `isRedirectPredicted` asks it too. */
export function landingPageRedirect(to: { matched: Pick<RouteRecordNormalized, 'path'>[], query: LocationQuery }, isExisting: boolean): string | undefined {
    const { landingPages = {}, security } = coreServerConfig(useRuntimeConfig())

    // Tag Assistant debugging stays on the landing page, where GTM debug support is enabled.
    if (security.enableGtmDebugSupport && 'gtm_debug' in to.query) return

    // The route's own path, not the URL's: routes match case-insensitively, so /AllSlots is /allslots.
    const route = to.matched[to.matched.length - 1]
    if (!route) return

    return landingPageTarget(landingPages, route.path, isExisting)
}
